import { v4 as uuidv4 } from 'uuid';

export class OrderEntryLeadtime {
    public id:number|null;
    public sort_order:number;
    public company_id:number;
    public postal_code_from_prefix:string|null;
    public postal_code_from_min:string|null;
    public postal_code_from_max:string|null;
    public postal_code_to_prefix:string|null;
    public postal_code_to_min:string|null;
    public postal_code_to_max:string|null;
    public leadtime_days:number|null;
    public to_county_id:number|null;
    public from_county_id:number|null;

    public guid:string;

    constructor(data:OrderEntryLeadtimeData|void) {
        this.guid = uuidv4();

        if(data === undefined)
        {
            this.id = null;
            this.sort_order = 0;
            this.company_id = 0;
            this.postal_code_from_prefix = "";
            this.postal_code_from_min = "";
            this.postal_code_from_max = "";
            this.postal_code_to_prefix = "";
            this.postal_code_to_min = "";
            this.postal_code_to_max = "";
            this.leadtime_days = null;
            this.to_county_id = null;
            this.from_county_id = null;
        }
        else
        {
            this.id = data.id;
            this.sort_order = data.sort_order;
            this.company_id = data.company_id;
            this.postal_code_from_prefix = data.postal_code_from_prefix;
            this.postal_code_from_min = data.postal_code_from_min;
            this.postal_code_from_max = data.postal_code_from_max;
            this.postal_code_to_prefix = data.postal_code_to_prefix;
            this.postal_code_to_min = data.postal_code_to_min;
            this.postal_code_to_max = data.postal_code_to_max;
            this.leadtime_days = data.leadtime_days;
            this.to_county_id = data.to_county_id;
            this.from_county_id = data.from_county_id;
        }
    }

    serializeData():OrderEntryLeadtimeData {
        return {
            id: this.id,
            sort_order: this.sort_order,
            company_id: this.company_id,
            postal_code_from_prefix: this.postal_code_from_prefix,
            postal_code_from_min: this.postal_code_from_min,
            postal_code_from_max: this.postal_code_from_max,
            postal_code_to_prefix: this.postal_code_to_prefix,
            postal_code_to_min: this.postal_code_to_min,
            postal_code_to_max: this.postal_code_to_max,
            leadtime_days: this.leadtime_days,
            to_county_id: this.to_county_id,
            from_county_id: this.from_county_id,
        }
    }
}

export type OrderEntryLeadtimeData = {
    id:number|null;
    sort_order:number;
    company_id:number;
    postal_code_from_prefix:string|null;
    postal_code_from_min:string|null;
    postal_code_from_max:string|null;
    postal_code_to_prefix:string|null;
    postal_code_to_min:string|null;
    postal_code_to_max:string|null;
    leadtime_days:number|null;
    to_county_id:number|null;
    from_county_id:number|null;
}